import {authToken} from 'storeState/auth/selectors';

const errorObject = (response, data) => {
    if(response.status !== 200) {
        return {
            status: data.status,
            statusCode: response.status,
            message: data.message,
        };
    } else {
        return null;
    }
}

export const responseObject = (response, data, requestAction) => {
    const error = null;

    return {
        payload: {
            data: data
        },
        error: errorObject(response, data),
        requestAction: requestAction
    }
}




// WEBPACK FOOTER //
// ./src/storeState/helpers.js